import React, { useState } from "react";

const InputOtp = ({
  icon,
  placeholder,
  onChange,
  isInvalid,
  onFocus,
  value,
}) => {
  const [otp, setOtp] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;

    if (/^\d*$/.test(value) && value.length <= 4) {
      setOtp(value);
      onChange(value);
    }
  };

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 flex items-center pl-3">
        <img src={icon} alt="icon" className="h-4 w-4" />
      </div>
      <input
        type="text"
        value={value ?? otp}
        maxLength={4}
        className={`form-input ${isInvalid && "!border-danger"} block h-12 w-full pl-10`}
        onChange={handleChange}
        onFocus={onFocus}
        placeholder={placeholder}
        required
      />
    </div>
  );
};

export default InputOtp;
